export enum FileUploadModalStates {
    CHOOSE_COA,
    UPLOAD_DIRECT_COA_FILES,
    CREATE_NEW_COA,
    CHOOSE_EXTERNAL_COA
}